import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button, Modal } from 'react-bootstrap';
import { FaPrint, FaReceipt } from 'react-icons/fa';

const pageStyle = `
  @page {
    size: 70mm 120mm;
  }

  @media all {
    .pagebreak { display: none; }
  }

  @media print {
    .pagebreak { page-break-before: always; }
  }
`;

function numberWithCommas(x) {
  x = (x ?? 0).toString();
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, '$1.$2');
  return x;
}

class CierreCajaView extends React.Component {
  render() {
    const d = this.props.cierreCajaData;
    const total = (d.montototaltarjeta ?? 0) + (d.montototalefectivo ?? 0);
    return (
      <pre className="cierre-receipt">
        CIERRE DE CAJA: {d.termino_fecha} {d.termino_hora}<br />
        Anterior:       {d.inicio_fecha} {d.inicio_hora}<br />
        {d.createuser && <>Usuario: {d.createuser}<br /></>}
        {d.local && <>Local: {d.local}<br /></>}
        Cajero: {d.device_name}<br />
        Numero Cierre: {d.secuencia_dia}<br />
        <br />
        Documentos Emitidos:  {('' + d.cantidaddocumentos).padStart(12)}<br />
        Folios:      Inicial -       Final<br />
        {d.rangos.map((e, idx) => (
          <React.Fragment key={idx}>
            Boleta:  {('' + e.folio_inicio).padStart(11)} - {('' + e.folio_fin).padStart(11)}<br />
          </React.Fragment>
        ))}
        <br />
        Total Efectivo:       {numberWithCommas(d.montototalefectivo).padStart(12)}<br />
        Total Tarjetas:       {numberWithCommas(d.montototaltarjeta).padStart(12)}<br />
        Total Ventas:         {numberWithCommas(total).padStart(12)}<br />
      </pre>
    );
  }
}

class PrintCierreCaja extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.cierreCajaData && this.props.cierreCajaData != null}
        onHide={this.props.onHide}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaReceipt className="me-2 text-primary" />
            Detalle de Cierre
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CierreCajaView
            cierreCajaData={this.props.cierreCajaData}
            ref={(el) => (this.componentRef = el)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onHide}>Cerrar</Button>
          <ReactToPrint
            trigger={() => (
              <Button variant="primary">
                <FaPrint className="me-2" />Imprimir
              </Button>
            )}
            content={() => this.componentRef}
            pageStyle={pageStyle}
            copyStyles={false}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PrintCierreCaja;
